import { defineMessages } from 'react-intl.macro';
import { VYJADRENI_PRIJATO } from '../constants';
import { UrcenyEditorZpsStatesEnum } from 'src/openapi/types/UrcenyEditorZpsStatesEnum';

export const svuMessages = defineMessages({
  title: {
    id: 'svuDetail.title',
    defaultMessage: '{id, select, empty {Nová SVÚ oblast} other {SVÚ oblast č. {id}}}',
  },
  pageTitle: {
    id: 'svuList.PageTitle',
    defaultMessage: 'Přehled SVÚ oblastí',
  },
  filteredEmpty: {
    id: 'svuList.state.filteredEmpty',
    defaultMessage: 'Zadanému filtru neodpovídá žádný záznam.',
  },
  id: {
    id: 'svuList.id',
    defaultMessage: 'ID',
  },
  state: {
    id: 'svuList.state',
    defaultMessage: 'Stav',
  },
  idUzemniEditace: {
    id: 'svuList.idUzemniEditace',
    defaultMessage: 'ID územní editace',
  },
  name: {
    id: 'svuList.name',
    defaultMessage: 'Název',
  },
  vyjadreniPrijato: {
    id: 'svuList.vyjadreniPrijato.title',
    defaultMessage: 'Přijato',
  },
  vyjadreniEditor: {
    id: 'svuDetail.vyjadreniEditor',
    defaultMessage: 'Správce vymenezené oblasti',
  },
  created: {
    id: 'svuList.created',
    defaultMessage: 'Vytvořeno',
  },
  createdGte: {
    id: 'svuFilter.createdGte',
    defaultMessage: 'Vytvořeno od',
  },
  createdLte: {
    id: 'svuFilter.createdLte',
    defaultMessage: 'Vytvořeno do',
  },
  edited: {
    id: 'svuList.edited',
    defaultMessage: 'Upraveno',
  },
  editedGte: {
    id: 'svuFilter.editedGte',
    defaultMessage: 'Upraveno od',
  },
  editedLte: {
    id: 'svuFilter.editedLte',
    defaultMessage: 'Upraveno do',
  },
  vyjadreniOduvodneni: {
    id: 'svuDetail.vyjadreniOduvodneni',
    defaultMessage: 'Odůvodnění',
  },
  sectionKraje: {
    id: 'svuDetail.section.kraje',
    defaultMessage: 'Informace předané krajem',
  },
  uzemniPusobnost: {
    id: 'svuDetail.uzemniPusobnost',
    defaultMessage: 'Náhled vymezeného územní',
  },
  fileUpload: {
    id: 'svuDetail.fileUpload',
    defaultMessage: 'Soubor s novou územní působností',
  },
  deleteUploadFileBtn: {
    id: 'svuDetail.deleteUploadFileBtn',
    defaultMessage: 'Smazat nahraný soubor',
  },
});

export const svuValidationErrors = defineMessages({
  nameError: {
    id: 'svuForm.name.error',
    defaultMessage: 'Vyplňte název SVÚ oblasti',
  },
  vyjadreniEditorError: {
    id: 'svuDetail.vyjadreniEditor.error',
    defaultMessage: 'Vyberte prosím editora SVÚ oblasti',
  },
  fileUploadError: {
    id: 'svuDetail.fileUpload.error',
    defaultMessage: 'Vyberte prosím ZIP/SHP soubor s územní působností',
  },
});

export const svuQueryMessages = defineMessages({
  loadQueryStateWaiting: {
    id: 'svu.load.queryState.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  loadQueryStateFail: {
    id: 'svu.load.queryState.fail',
    defaultMessage: 'Zobrazení informací o SVÚ oblasti se nepovedlo. Zkuste to prosím později.',
  },
  submitQueryStateWaiting: {
    id: 'svu.submit.queryState.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  submitQueryStateSuccess: {
    id: 'svu.submit.success',
    defaultMessage: 'Změny uloženy.',
  },
  submitQueryStateFail: {
    id: 'svu.submit.fail',
    defaultMessage: 'Uložení změn se nepovedlo. Zkuste to prosím později.',
  },
  deleteQueryStateFail: {
    id: 'svu.delete.fail',
    defaultMessage: 'Smazání SVÚ oblasti se nepovedlo. Zkuste to prosím později.',
  },
  waiting: {
    id: 'svuList.state.waiting',
    defaultMessage: 'Seznam SVÚ oblastí se načítá.',
  },
  fail: {
    id: 'svuList.state.fail',
    defaultMessage: 'Seznam SVÚ oblastí se nepovedlo načíst.',
  },
});

export const svuBtnMessages = defineMessages({
  filterSubmit: {
    id: 'svu.btn.filterSubmit',
    defaultMessage: 'Filtrovat',
  },
  filter: {
    id: 'svu.btn.filter',
    defaultMessage: 'Filtr',
  },
  clear: {
    id: 'svu.btn.clear',
    defaultMessage: 'Vyčistit',
  },
  save: {
    id: 'svu.btn.save',
    defaultMessage: 'Odeslat do ISDMVS',
  },
  delete: {
    id: 'svu.btn.delete',
    defaultMessage: 'Odebrat z ISDMVS',
  },
  deleteAlert: {
    id: 'svu.btn.deleteAlert',
    defaultMessage: 'Opravdu chcete odebrat SVÚ oblast z ISDMVS?',
  },
  deleteFileAlert: {
    id: 'svu.btn.deleteFileAlert',
    defaultMessage: 'Opravdu chcete smazat nahraný soubor?',
  },
});

export const isVyjadreniPrijatoMessages = defineMessages<VYJADRENI_PRIJATO>({
  [VYJADRENI_PRIJATO.TRUE]: {
    id: 'svuDetail.vyjadreniPrijato.TRUE',
    defaultMessage: 'Ano',
  },
  [VYJADRENI_PRIJATO.FALSE]: {
    id: 'svuDetail.vyjadreniPrijato.FALSE',
    defaultMessage: 'Ne',
  },
});

export const stateMessages = defineMessages<UrcenyEditorZpsStatesEnum>({
  [UrcenyEditorZpsStatesEnum.SET_EDITOR_ACCEPTED]: {
    id: 'svu.state.setEditorAccepted',
    defaultMessage: 'Vytvoření oblasti schváleno',
  },
  [UrcenyEditorZpsStatesEnum.SET_EDITOR_REJECTED]: {
    id: 'svu.state.setEditorRejected',
    defaultMessage: 'Vytvoření oblasti zamítnuto',
  },
  [UrcenyEditorZpsStatesEnum.SET_EDITOR_SENDING]: {
    id: 'svu.state.setEditorSending',
    defaultMessage: 'Žádám o vytvoření oblasti',
  },
  [UrcenyEditorZpsStatesEnum.SET_EDITOR_SENDING_FAILED]: {
    id: 'svu.state.setEditorSendingFailed',
    defaultMessage: 'Žádost o vytvoření oblasti selhala',
  },
  [UrcenyEditorZpsStatesEnum.SET_EDITOR_RECEIVING]: {
    id: 'svu.state.setEditorReceiving',
    defaultMessage: 'Čekám na schválení vytvořneí oblasti',
  },
  [UrcenyEditorZpsStatesEnum.SET_EDITOR_RECEIVING_FAILED]: {
    id: 'svu.state.setEditorReceivingFailed',
    defaultMessage: 'Žádost o vytvoření oblasti selhala',
  },
  [UrcenyEditorZpsStatesEnum.CHANGE_AREA_ACCEPTED]: {
    id: 'svu.state.changeAreaAccepted',
    defaultMessage: 'Změna oblasti schválena',
  },
  [UrcenyEditorZpsStatesEnum.CHANGE_AREA_REJECTED]: {
    id: 'svu.state.changeAreaRejected',
    defaultMessage: 'Změna oblasti zamítnuto',
  },
  [UrcenyEditorZpsStatesEnum.CHANGE_AREA_SENDING]: {
    id: 'svu.state.changeAreaSending',
    defaultMessage: 'Žádám o změnu oblasti',
  },
  [UrcenyEditorZpsStatesEnum.CHANGE_AREA_SENDING_FAILED]: {
    id: 'svu.state.changeAreaSendingFailed',
    defaultMessage: 'Žádost o změnu oblasti selhala',
  },
  [UrcenyEditorZpsStatesEnum.CHANGE_AREA_RECEIVING]: {
    id: 'svu.state.changeAreaReceiving',
    defaultMessage: 'Čekám na schválení změny oblasti',
  },
  [UrcenyEditorZpsStatesEnum.CHANGE_AREA_RECEIVING_FAILED]: {
    id: 'svu.state.changeAreaReceivingFailed',
    defaultMessage: 'Schválení změny oblasti selhalo',
  },
  [UrcenyEditorZpsStatesEnum.REVOKE_AREA_FAILED]: {
    id: 'svu.state.revokeAreaFailed',
    defaultMessage: 'Smazání oblasti selhalo',
  },
  [UrcenyEditorZpsStatesEnum.PREPARED_TO_SEND]: {
    id: 'svu.state.preparedToSend',
    defaultMessage: 'Připraven k odeslání do DMVS',
  },
});
